import { basic, initTopbar } from './modules/layouts';
import { categoryCollapse } from './modules/components';

basic();
initTopbar();
categoryCollapse();
